// extracted by mini-css-extract-plugin
export default {"notifications":"styles_notifications__Ib4Zk","notification":"styles_notification__1R+GY"};